import React from 'react';

import { SectionSkeleton } from 'app/component/skeleton/section/SectionSkeleton';
import { PlateSkeleton } from 'app/component/skeleton/plate/PlateSkeleton';
import { RepeatComponent } from 'app/component/repeat-component/RepeatComponent';
import { FieldSkeleton } from 'app/component/skeleton/field/FieldSkeleton';
import { RowListSkeleton } from 'app/component/skeleton/row/RowListSkeleton';
import { useWindowType } from 'app/utils/useWindowType';

import './OrderSkeleton.less';

export const OrderSkeleton = () => {
    const [windowType] = useWindowType();

    return (
        <div className="OrderSkeleton">
            <PlateSkeleton windowType={windowType} />
            <div style={{ marginTop: 24 }}>
                <SectionSkeleton />
            </div>
            <div style={{ marginTop: 32 }}>
                <RepeatComponent numberRepetitions={3}>
                    <div style={{ marginTop: 24 }}>
                        <RowListSkeleton rowCount={1} windowType={windowType} />
                    </div>
                </RepeatComponent>
            </div>
            <div style={{ marginTop: 32 }}>
                <FieldSkeleton windowType={windowType} />
            </div>
            <div style={{ marginTop: 24 }}>
                <FieldSkeleton windowType={windowType} />
            </div>
        </div>
    );
};
